// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__380R1","rootSuccess":"CompleteLink_rootSuccess__1917y","rootFailure":"CompleteLink_rootFailure__3XSuC","isDisabled":"CompleteLink_isDisabled__jTHML"};